import type { ChangeEvent, FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Body } from 'components-stateless/DesignSystem/Atoms/Fonts';

const OptionWrapper = styled.div<{ width: string }>`
  display: flex;
  justify-content: space-between;
  width: ${({ width }) => width};
`;

interface IItem {
  label: string | React.ReactNode;
  value: string | undefined;
  disabled?: boolean;
  labelElement?: React.ReactNode;
}

interface IRadioGroupProps {
  id?: string;
  name: string;
  options: IItem[];
  isRow?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  value: string | undefined;
  width?: string;
}

const RadioGroupField: FunctionComponent<IRadioGroupProps> = ({
  id,
  name,
  options,
  isRow,
  value,
  onChange,
  width = '100%',
}) => (
  <FormControl>
    <RadioGroup
      name={name}
      value={value}
      onChange={onChange}
      row={isRow}
      id={id || name}
    >
      {options.map((o) => (
        <OptionWrapper key={`key-${o.value}`} width={width}>
          <FormControlLabel
            value={o.value}
            control={<Radio disabled={o.disabled || false} />}
            label={<Body>{o.label}</Body>}
          />
          {o.labelElement || null}
        </OptionWrapper>
      ))}
    </RadioGroup>
  </FormControl>
);

export default RadioGroupField;
